/**
 * Kinng.app — Audit Logs API (super-admin).
 */
import api from "./api";

export const auditApi = {
    list: (params = {}) => {
        const qs = new URLSearchParams(
            Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "")
        ).toString();
        return api.get(`/admin/audit-logs${qs ? `?${qs}` : ""}`);
    },
    summary: () => api.get("/admin/audit-logs/summary"),
    exportCsvUrl: (params = {}) => {
        const qs = new URLSearchParams(
            Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "" && v !== "all")
        ).toString();
        const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
        return `${base}/api/admin/audit-logs/export${qs ? `?${qs}` : ""}`;
    },
};

export default auditApi;
